module.exports = __webpack_public_path__ + "static/2-ea130652f91a7461108c71ad1ce079f1.png";